module.exports = __webpack_public_path__ + "static/media/m_eyebrowshape_rounded.c9804e6b.png";